var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.172 2a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 20 6.828V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM13 4H6v16h12V9h-3c-1.103 0-2-.897-2-2zm0 11a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2Zm2-3.999a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2ZM10 7a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2Zm5.172-3H15v3h3v-.172z"
})));
export default SvgGemFile;